// Machine-translated — pending native review.
const ko: Record<string, string> = {
  // ── App ──────────────────────────────────────────────────────────────────
  'app.title': 'XTM Express',

  // ── Login ────────────────────────────────────────────────────────────────
  'login.title': 'XTM Express',
  'login.subtitle': '기업용 AI 번역 포털',
  'login.description': '회사 자격 증명으로 로그인하여 문서 번역을 시작하세요',
  'login.ssoButton': 'SSO로 로그인',
  'login.footer': 'Zitadel · OAuth 2.1로 보안 처리',

  // ── Header ───────────────────────────────────────────────────────────────
  'header.title': 'XTM Express',
  'header.avatarLabel': '사용자 메뉴',
  'header.languageLabel': '언어 선택',

  // ── Stepper ──────────────────────────────────────────────────────────────
  'stepper.upload': '업로드',
  'stepper.analyze': '분석',
  'stepper.translate': '번역',

  // ── Upload Page ──────────────────────────────────────────────────────────
  'upload.title': '콘텐츠 업로드',
  'upload.tab.file': '파일 업로드',
  'upload.tab.text': '텍스트 입력',
  'upload.text.placeholder': '번역할 텍스트를 붙여넣거나 입력하세요…',
  'upload.text.charCount': '{count} / {max}자',
  'upload.text.tooLong': '텍스트가 {max}자 제한을 초과했습니다. 줄여 주세요.',
  'upload.dropzone.title': '여기에 파일을 놓으세요',
  'upload.dropzone.or': '또는',
  'upload.dropzone.browse': '파일 찾아보기',
  'upload.dropzone.formats': '{formats} 형식을 지원합니다 · 최대 5개 파일 · 파일당 10 MB',
  'upload.sourceLanguage': '원본 언어',
  'upload.sourceLanguage.placeholder': '원본 언어 선택...',
  'upload.targetLanguages': '대상 언어',
  'upload.targetLanguages.placeholder': '대상 언어 검색 및 선택...',
  'upload.targetLanguages.selected': '{count}개 언어 선택됨',
  'languagePicker.loading': '언어를 불러오는 중…',
  'languagePicker.loadError': '언어 목록을 불러오지 못했습니다.',
  'languagePicker.retry': '다시 시도',
  'languagePicker.noMatch': '“{query}”와 일치하는 언어나 변형이 없습니다.',
  'languagePicker.regionalVariants': '지역 변형',
  'languagePicker.showMore': '{language} 변형 {count}개 더 보기',
  'languagePicker.default': '기본값',
  'languagePicker.variantCount': '변형 {count}개',
  'languagePicker.languageOption': '{language}, 변형 {count}개, {selected}개 선택됨',
  'languagePicker.showVariants': '{language} 변형 보기',
  'languagePicker.hideVariants': '{language} 변형 숨기기',
  'languagePicker.remove': '{name} 제거',
  'languagePicker.changeVariant': '{language} 변형 변경',
  'languagePicker.changeVariantOf': '{name} 변형 변경',
  'languagePicker.searchVariants': '변형 {count}개 검색…',
  'languagePicker.searchVariantsOf': '{language} 변형 검색',
  'languagePicker.noVariantMatch': '일치하는 변형이 없습니다.',
  'languagePicker.allVariants': '모든 변형',
  'languagePicker.added': '추가됨',
  'languagePicker.keys.move': '이동',
  'languagePicker.keys.toggle': '선택 / 선택 해제',
  'languagePicker.keys.expand': '변형 보기',
  'languagePicker.keys.collapse': '변형 숨기기',
  'languagePicker.keys.clear': '검색 지우기',
  'upload.files.summary': '{count}개 파일 업로드됨 · {size}',
  'upload.files.column.name': '파일',
  'upload.files.column.size': '크기',
  'upload.files.column.actions': '',
  'upload.files.remove': '파일 제거',
  'upload.files.addMore': '파일 추가',
  'upload.analyzeButton': '콘텐츠 분석',
  'upload.maxFiles': '최대 5개 파일까지 업로드할 수 있습니다. 일부 파일은 추가되지 않았습니다.',
  'upload.error.unsupportedType': '“{name}”은(는) 지원되지 않는 형식이므로 추가되지 않았습니다. 지원 형식: {formats}',
  'upload.error.zipTooMany': '“{name}”에는 {count}개의 파일이 들어 있습니다. zip에는 최대 5개의 파일을 포함할 수 있습니다.',
  'upload.uploading': '파일 업로드 중...',
  'upload.error': '업로드에 실패했습니다. 다시 시도해 주세요.',
  'upload.error.tooLarge': '파일 "{name}"이(가) 업로드 한도 {max}을(를) 초과합니다. 더 작은 파일을 선택해 주세요.',

  // ── Analysis Page ────────────────────────────────────────────────────────
  'analysis.title': 'AI 위험 분석',
  'analysis.subtitle': 'AI 엔진이 각 파일의 번역 복잡도와 규제 위험을 평가했습니다. 각 파일의 제안 레인을 확인한 후 수락하거나 다른 레인을 선택하세요.',
  'analysis.risk.high': '높은 위험',
  'analysis.risk.low': '낮은 위험',
  'analysis.risk.high.tooltip': '번역 오류가 실제 위험을 초래할 수 있는 민감하거나 복잡하거나 비즈니스에 중요한 콘텐츠입니다. 전문 검토자에게 전달됩니다.',
  'analysis.risk.low.tooltip': 'AI 엔진이 단독으로 안정적으로 번역할 수 있는 간단한 콘텐츠입니다. 즉시 번역되어 다운로드할 수 있습니다.',
  'analysis.risk.borderline': '경계 근처',
  'analysis.risk.failed': '분석 실패',
  'analysis.risk.failed.tooltip': '이 파일의 AI 위험 분석에 실패하여 위험 수준이 결정되지 않았습니다. 안전 장치로, 전문 언어 전문가가 파일을 처리하는 휴먼 인 더 센터를 제안합니다.',
  'analysis.risk.failed.message': '위험 분석 실패 — 안전 장치로 휴먼 인 더 센터를 제안합니다.',
  'analysis.failedBanner': '{count, plural, one {# 개 파일} other {# 개 파일}}의 위험 분석에 실패했습니다. LLM 연결이 올바른지 확인한 후 파일을 다시 업로드하거나 텍스트를 다시 입력하세요.',
  'analysis.risk.failed.message.timedOut': '위험 분석이 {minutes, plural, one {# 분} other {# 분}} 안에 끝나지 않아 위험 수준이 결정되지 않았습니다. 안전 장치로 휴먼 인 더 센터를 제안합니다.',
  'analysis.risk.failed.message.timedOutNoLimit': '위험 분석이 제시간에 끝나지 않아 위험 수준이 결정되지 않았습니다. 안전 장치로 휴먼 인 더 센터를 제안합니다.',
  'analysis.risk.failed.message.assessmentFailed': '위험 분석 서비스가 이 파일을 평가하지 못해 위험 수준이 결정되지 않았습니다. 안전 장치로 휴먼 인 더 센터를 제안합니다.',
  'analysis.risk.failed.message.noLlmConnector': '조직에 LLM 연결이 설정되어 있지 않아 이 파일은 평가되지 않았습니다. 안전 장치로 휴먼 인 더 센터를 제안합니다.',
  'analysis.failedBanner.timedOut': '{count, plural, one {# 개 파일} other {# 개 파일}}의 위험 분석이 제시간에 끝나지 않았습니다. 안전 장치로 휴먼 인 더 센터를 제안합니다. AI-Direct를 선택할 수도 있습니다.',
  'analysis.unreadable.badge': '파일을 읽을 수 없음',
  'analysis.unreadable.message': '<b>XTM Go가 이 파일을 분석하지 못했습니다</b>. 평가되지 않았으므로 번역할 수 없습니다.',
  'analysis.unreadable.remove': '배치에서 제거',
  'analysis.unreadable.remove.aria': '배치에서 {filename} 제거',
  'analysis.unreadable.removed': '배치에서 제거됨, 번역되지 않습니다.',
  'analysis.unreadable.undo': '실행 취소',
  'analysis.unreadable.undo.aria': '{filename} 제거 실행 취소',
  'analysis.unreadable.banner.single': '<b>이 파일을 읽을 수 없어 번역할 수 없습니다.</b> 파일을 수정한 후 새 번역을 시작하세요.',
  'analysis.unreadable.banner.all': '<b>파일 {count}개를 모두 읽을 수 없어 번역할 내용이 없습니다.</b> 파일을 수정한 후 새 번역을 시작하세요.',
  'analysis.unreadable.banner.some': '<b>파일 {count}개를 읽을 수 없어 아직 이 배치를 번역할 수 없습니다.</b> 배치에서 파일 {count}개를 제거하면 나머지 파일 {others}개를 번역할 수 있습니다.',
  'analysis.translateButton.removeFailed': '실패한 파일 {count}개를 제거하고 번역',
  'analysis.announce.removeFirst': '번역하기 전에 읽을 수 없는 파일 {count}개를 제거하세요.',
  'analysis.announce.removed': '{filename}이(가) 배치에서 제거되었습니다. 번역되지 않습니다.',
  'analysis.announce.restored': '{filename}이(가) 배치에 다시 추가되었습니다. 포함되어 있는 동안에는 배치를 번역할 수 없습니다.',
  'analysis.route.aiDirect': 'AI-Direct',
  'analysis.route.xtmCloud': '휴먼 인 더 센터',
  'analysis.route.aiDirect.tooltip': 'AI가 즉시 번역하여 몇 분 안에 다운로드할 수 있습니다. 위험이 낮은 콘텐츠에 권장됩니다.',
  'analysis.route.xtmCloud.tooltip': '전달 전에 전문 번역가의 검토를 거칩니다. 위험이 높거나 복잡한 콘텐츠에 권장됩니다.',
  'analysis.translateButton': '번역',
  'analysis.translateButton.files': '파일 {count}개 번역',
  'analysis.translateButton.decideMore': '번역하려면 {count}개 더 결정하세요',
  'analysis.translateButton.decideSingle': '번역하려면 레인을 수락하거나 변경하세요',
  'analysis.risk.borderline.hint': '<b>경계 근처:</b> 점수가 낮은 위험과 높은 위험의 경계에 가까워 제안이 반대로 나올 수도 있었습니다. 이 파일을 주의 깊게 확인하세요.',
  'analysis.suggestion.label': 'AI 제안',
  'analysis.suggestion.labelFailSafe': '안전 장치 제안',
  'analysis.decision.accept': '제안 수락',
  'analysis.decision.accept.aria': '{filename}에 대한 제안 수락',
  'analysis.decision.useOther': '대신 {lane} 사용',
  'analysis.decision.useOther.aria': '{filename}에 대신 {lane} 사용',
  'analysis.decision.accepted': '수락됨: <b>{lane}</b>',
  'analysis.decision.changed': '<b>{lane}</b>(으)로 변경됨 (AI 제안: {suggested})',
  'analysis.decision.changedFailSafe': '<b>{lane}</b>(으)로 변경됨 (안전 장치 제안: {suggested})',
  'analysis.decision.change': '변경',
  'analysis.decision.change.aria': '{filename}에 대한 결정 변경',
  'analysis.decision.acceptAll': '남은 제안 모두 수락',
  'analysis.styleGuide.label': '스타일 가이드',
  'analysis.languagePair.aria': '{source}에서 {targets}(으)로 번역',
  'analysis.languagePair.noSource.aria': '{targets}(으)로 번역',
  'analysis.styleGuide.choose.aria': '{filename}의 스타일 가이드: {name}',
  'analysis.styleGuide.popup.aria': '스타일 가이드 선택',
  'analysis.styleGuide.default': '기본값',
  'analysis.styleGuide.none': '스타일 가이드 없음',
  'analysis.styleGuide.none.description': '이 파일을 스타일 가이드 없이 번역합니다.',
  'analysis.styleGuide.search': '이름 또는 언어 코드로 검색',
  'analysis.styleGuide.search.aria': '스타일 가이드 검색',
  'analysis.styleGuide.noMatch': '“{query}”와 일치하는 스타일 가이드가 없습니다.',
  'analysis.styleGuide.updated': '{date} 업데이트됨',
  'analysis.styleGuide.help.default': '번역을 시작할 때의 조직 기본 스타일 가이드를 따릅니다.',
  'analysis.styleGuide.help.none': '이 파일은 스타일 가이드 없이 번역됩니다. 조직의 기본값은 <b>{name}</b>입니다.',
  'analysis.styleGuide.help.noneNoDefault': '이 파일은 스타일 가이드 없이 번역됩니다.',
  'analysis.styleGuide.help.selected': '기본값(<b>{name}</b>)에서 변경되었습니다. {languages}에 적용됩니다.',
  'analysis.styleGuide.help.selectedNoDefault': '기본값(스타일 가이드 없음)에서 변경되었습니다. {languages}에 적용됩니다.',
  'analysis.styleGuide.help.selectedNoLanguages': '기본값(<b>{name}</b>)에서 변경되었습니다.',
  'analysis.styleGuide.help.selectedNoDefaultNoLanguages': '기본값(스타일 가이드 없음)에서 변경되었습니다.',
  'analysis.styleGuide.useDefault': '기본값 사용',
  'analysis.styleGuide.loadFailed': '스타일 가이드를 불러올 수 없습니다. 이 파일에는 조직의 기본값이 사용됩니다.',
  'analysis.styleGuide.loading': '스타일 가이드를 불러오는 중…',
  'analysis.styleGuide.refreshFailed': '목록을 새로 고치지 못했습니다. 선택한 항목은 유지됩니다.',
  'analysis.xtmCloud.customer.label': 'XTM Cloud 고객',
  'analysis.xtmCloud.template.label': '프로젝트 템플릿',
  'analysis.xtmCloud.customer.choose.aria': '{filename}의 XTM Cloud 고객: {name}',
  'analysis.xtmCloud.template.choose.aria': '{filename}의 프로젝트 템플릿: {name}',
  'analysis.xtmCloud.customer.popup.aria': 'XTM Cloud 고객 선택',
  'analysis.xtmCloud.template.popup.aria': '프로젝트 템플릿 선택',
  'analysis.xtmCloud.search': '이름으로 검색',
  'analysis.xtmCloud.customer.search.aria': 'XTM Cloud 고객 검색',
  'analysis.xtmCloud.template.search.aria': '프로젝트 템플릿 검색',
  'analysis.xtmCloud.customer.noMatch': '“{query}”와 일치하는 고객이 없습니다.',
  'analysis.xtmCloud.template.noMatch': '“{query}”와 일치하는 템플릿이 없습니다.',
  'analysis.xtmCloud.default': '기본값',
  'analysis.xtmCloud.customer.automatic': 'XTM Go(자동 생성)',
  'analysis.xtmCloud.customer.unknown': '고객 {id}',
  'analysis.xtmCloud.template.none': '템플릿 없음',
  'analysis.xtmCloud.template.global': '전역',
  'analysis.xtmCloud.template.unknown': '템플릿 {id}',
  'analysis.xtmCloud.help.default': '파일을 XTM Cloud로 보낼 때의 조직 기본 고객과 템플릿을 따릅니다.',
  'analysis.xtmCloud.help.selected': '기본값(<b>{customer}</b>, <b>{template}</b>)에서 변경되었습니다.',
  'analysis.xtmCloud.help.selectedAutomatic': '기본값에서 변경되었습니다: <b>XTM Go</b>, 자동 생성됨; <b>{template}</b>.',
  'analysis.xtmCloud.useDefault': '기본값 사용',
  'analysis.xtmCloud.loading': '고객을 불러오는 중…',
  'analysis.xtmCloud.templates.loading': '템플릿을 불러오는 중…',
  'analysis.xtmCloud.loadFailed': 'XTM Cloud 고객을 불러올 수 없습니다. 이 파일에는 조직의 기본 고객과 템플릿이 사용됩니다.',
  'analysis.xtmCloud.templates.loadFailed': '이 고객의 템플릿을 불러올 수 없습니다.',
  'analysis.xtmCloud.refreshFailed': '목록을 새로 고치지 못했습니다. 선택한 항목은 유지됩니다.',
  'analysis.laneDecision.styleGuideGone': '{filename}에 선택한 스타일 가이드가 더 이상 없습니다. 다른 것을 선택하세요.',
  'analysis.laneDecision.xtmCustomerGone': '{filename}에 선택한 XTM Cloud 고객을 더 이상 사용할 수 없습니다. 다른 고객을 선택하세요.',
  'analysis.laneDecision.xtmTemplateGone': '{filename}에 선택한 프로젝트 템플릿을 더 이상 사용할 수 없습니다. 다른 템플릿을 선택하세요.',
  'analysis.laneDecision.xtmCloudUnavailable': 'XTM Go가 XTM Cloud에 연결할 수 없어 {filename}에 선택한 고객과 템플릿을 확인하지 못했습니다. 다시 시도하세요.',
  'analysis.announce.accepted': '{filename}: {lane} 수락됨.',
  'analysis.announce.changed': '{filename}: {lane}(으)로 변경됨.',
  'analysis.announce.cleared': '{filename}: 결정이 지워졌습니다.',
  'analysis.announce.acceptedAll': '파일 {count}개에 대해 AI 제안을 수락했습니다. 모든 파일이 결정되었습니다.',
  'analysis.announce.decideFirst': '먼저 남은 파일 {count}개의 레인을 결정하세요.',
  'analysis.announce.decideFirstSingle': '먼저 레인을 수락하거나 변경하세요.',
  'analysis.backToUpload': '업로드로 돌아가기',
  'analysis.loading.hint': '보통 1분 이내로 완료됩니다. 이 탭을 열어 두셔도 됩니다 — 자동으로 업데이트됩니다.',
  'analysis.loading.status.STARTING': '시작하고 있습니다…',
  'analysis.loading.status.PENDING_UPLOAD': '문서를 기다리고 있습니다…',
  'analysis.loading.status.UPLOADING': '문서를 업로드하고 있습니다…',
  'analysis.loading.status.PARSING': '문서를 읽고 있습니다…',
  'analysis.loading.status.READY_FOR_ANALYSIS': '분석 대기 중입니다…',
  'analysis.loading.status.ANALYZING': '문서의 위험을 평가하고 있습니다…',
  'analysis.loading.status.ANALYZED': '분석을 마무리하고 있습니다…',
  'analysis.loading.status.FETCHING_REPORT': '결과를 정리하고 있습니다…',
  'analysis.polling.progress': '{total}개 문서 중 {current}번째',
  'analysis.error': '분석에 실패했습니다. 다시 시도해 주세요.',
  'analysis.retry': '다시 시도',
  'analysis.laneDecision.submitting': '레인 결정 제출 중...',
  'analysis.laneDecision.error': '레인 결정 제출에 실패했습니다. 다시 시도해 주세요.',
  'analysis.deadline': '{deadline}까지 레인을 선택하세요. 그 이후에는 업로드한 파일이 보관되지 않으므로 다시 업로드해야 합니다.',
  'analysis.sourceExpired': '업로드한 파일이 더 이상 보관되지 않아 번역할 수 없습니다. 새 번역을 시작해 다시 업로드하세요.',
  'analysis.sourceExpired.partial': '업로드한 파일이 더 이상 보관되지 않아 아직 보내지 않은 파일은 번역할 수 없습니다. 이미 보낸 파일은 계속 진행됩니다.',
  'analysis.sourceExpired.showSent': '이미 보낸 파일 보기',
  'analysis.startNew.confirmTitle': '이 번역을 중단할까요?',
  'analysis.startNew.confirmBody': '이 번역을 중단하고 새로 시작할까요? 업로드한 파일은 어느 것도 번역되지 않습니다.',
  'analysis.startNew.confirmButton': '중단하고 새로 시작',
  'analysis.startNew.cancel': '취소',
  'analysis.startNew.error': '새 번역을 시작하지 못했습니다. 다시 시도해 주세요.',
  'analysis.noData': '분석할 문서가 없습니다. 돌아가서 파일을 업로드해 주세요.',
  'analysis.riskReport.button': '위험 보고서',
  'analysis.riskReport.veto': '거부권 발동됨',
  'analysis.riskReport.failed': '요인 실패',
  'analysis.riskReport.factor.criticalDownstreamImpactRisk': '치명적 후속 영향',
  'analysis.riskReport.factor.structuralFormatIntegrityRisk': '구조 / 형식 무결성',
  'analysis.riskReport.factor.domainDifficultyClassification': '도메인 난이도',
  'analysis.riskReport.factor.referencelessTranslationDifficultyEstimation': '번역 난이도',

  // ── Translate Page ───────────────────────────────────────────────────────
  'translate.progress.title': '콘텐츠 번역 중...',
  'translate.progress.info': '{total}개 문서 중 {current}개 처리 중',
  'translate.progress.hint': '보통 몇 분 정도 걸립니다. 이 탭을 열어 두셔도 됩니다 — 자동으로 업데이트됩니다.',
  'translate.progress.stage.prepare': 'AI 엔진을 위해 콘텐츠를 준비하고 있습니다…',
  'translate.progress.stage.context': '각 세그먼트의 문맥을 파악하고 있습니다…',
  'translate.progress.stage.translate': '세그먼트별로 번역하고 있습니다…',
  'translate.progress.stage.terminology': '용어와 어조의 일관성을 유지하고 있습니다…',
  'translate.progress.stage.quality': '서식과 구조를 확인하고 있습니다…',
  'translate.complete.title': '처리 완료',
  'translate.complete.filesReady': '{count, plural, one {# file is} other {# files are}} 다운로드할 준비가 되었습니다.',
  'translate.complete.inReview': '{count, plural, one {# 개 문서를} other {# 개 문서를}} 휴먼 인 더 센터 플로우로 TMS에 보냈습니다. 번역된 파일을 다운로드할 수 있게 되면 이메일로 알려 드립니다.',
  'translate.complete.expandAll': '모두 펼치기',
  'translate.complete.collapseAll': '모두 접기',
  'translate.complete.showLanguages': '{document}의 번역된 파일 표시',
  'translate.complete.hideLanguages': '{document}의 번역된 파일 숨기기',
  'translate.complete.fileCount': '{count, plural, other {파일 #개}}',
  'translate.complete.readyOf': '{total}개 중 {ready}개 완료',
  'translate.complete.languagesNotDelivered': '{count, plural, other {#개 언어가 전달되지 않았습니다.}}',
  'translate.complete.languagesWithWarning': '{count, plural, other {#개 언어가 경고와 함께 전달되었습니다.}}',
  'translate.partial.banner.title': '일부 문서에 주의가 필요합니다',
  'translate.partial.banner.description': '일부 작업이 실패했습니다. 아래에서 실패한 작업을 다시 시도할 수 있습니다.',
  'translate.table.column.file': '문서',
  'translate.table.column.language': '언어',
  'translate.table.column.route': '레인',
  'translate.table.column.status': '상태',
  'translate.table.column.action': '작업',
  'translate.status.PENDING': '대기 중',
  'translate.status.QUEUED': '대기열에 추가됨',
  'translate.status.PROCESSING': '처리 중',
  'translate.status.GENERATING_TARGETS': '번역 생성 중',
  'translate.status.TRANSLATING': '번역 중',
  'translate.status.DELIVERING': '전달 중',
  'translate.status.IN_PROGRESS': '진행 중',
  'translate.status.COMPLETED': '완료됨',
  'translate.status.FAILED': '실패함',
  'translate.status.inReview': '사람 검토 중',
  'translate.status.sent': '전송됨',
  'translate.action.download': '다운로드',
  'translate.action.viewInXtm': '검토 보기',
  'translate.action.retry': '다시 시도',
  'translate.action.downloading': '다운로드 중...',
  'translate.action.retrying': '다시 시도 중...',
  'translate.action.retried': '다시 시도함',
  'translate.action.downloadAll': '모두 다운로드',
  'translate.action.downloadLanguage': '{document}, {language} 다운로드',
  'translate.action.downloaded': '다운로드됨',
  'translate.newTranslation': '새 번역 시작',
  'translate.downloadAll': 'ZIP으로 모두 다운로드',
  'translate.downloadCompleted': '완료된 항목 다운로드',
  'translate.loading': '번역 작업 준비 중...',
  'translate.error': '번역에 실패했습니다. 다시 시도해 주세요.',
  'translate.noJobs': '번역 작업을 찾을 수 없습니다. 돌아가서 레인 결정을 제출해 주세요.',
  'translate.failureReason': '사유: {reason}',
  'translate.retry.error': '다시 시도하지 못했습니다. 다시 시도하세요.',
  'translate.retry.sourceExpired': '업로드한 파일이 더 이상 보관되지 않아 다시 시도할 수 없습니다. 새 번역에서 다시 업로드하세요.',

  // ── Languages ────────────────────────────────────────────────────────────
  'language.en': '영어',
  'language.fr': '프랑스어',
  'language.de': '독일어',
  'language.es': '스페인어',
  'language.ja': '일본어',
  'language.zh': '중국어(간체)',
  'language.pt': '포르투갈어',
  'language.it': '이탈리아어',
  'language.ko': '한국어',
  'language.ar': '아랍어',
  'language.nl': '네덜란드어',
  'language.pl': '폴란드어',
  'language.sv': '스웨덴어',
  'language.el': '그리스어',

  // ── Shared ───────────────────────────────────────────────────────────────
  'shared.loading': '로딩 중...',
  'shared.error.title': '문제가 발생했습니다',
  'shared.error.description': '예기치 않은 오류가 발생했습니다. 페이지를 새로 고침해 주세요.',
  'shared.error.retry': '다시 시도',
  'shared.empty': '사용 가능한 데이터가 없습니다',

  // ── Auth / Admin / Translated files (added in PR #7 merge) ──
  'header.home': 'XTM Go 홈',
  'header.signOut': '로그아웃',
  'header.adminXtmCloud': '설정',
  'header.translatedFiles': '번역된 파일',
  'header.help': '도움말 및 리소스',
  'header.help.documentation': '문서',
  'header.help.apiDocumentation': 'API 문서',
  'auth.callback.loading': '로그인 중…',
  'accessDenied.title': '접근 거부됨',
  'accessDenied.body': '로그인되었지만 귀하의 계정에는 XTM Go 접근 권한이 부여되지 않았습니다. 오류라고 생각되시면 관리자에게 문의하세요.',
  'admin.xtmCloud.title': '설정',
  'admin.xtmCloud.subtitle': 'XTM Cloud 통합 및 AI 번역 설정을 관리합니다.',
  'admin.xtmCloud.status.done': '구성됨',
  'admin.xtmCloud.status.pending': '대기 중',
  'admin.xtmCloud.overview.title': '설정 개요',
  'admin.xtmCloud.nav.label': '구성 섹션',
  'admin.xtmCloud.nav.unsaved': '저장되지 않은 변경 사항이 있음',
  'admin.xtmCloud.customer.problem.authentication': 'XTM Cloud가 저장된 인증 정보를 거부해 목록을 불러올 수 없습니다. 위에서 수정한 뒤 저장하세요.',
  'admin.xtmCloud.customer.problem.unavailable': 'XTM Cloud가 응답하지 않아 목록을 불러올 수 없습니다. 저장된 인증 정보에는 이상이 없습니다.',
  'admin.xtmCloud.nav.problem': 'XTM Cloud 연결이 작동하지 않음',
  'admin.xtmCloud.retry': '다시 시도',
  'admin.xtmCloud.connector.title': 'LLM 커넥터',
  'admin.xtmCloud.footer.unsaved': '저장되지 않은 변경 사항',
  'admin.xtmCloud.footer.save': '변경 사항 저장',
  'admin.xtmCloud.footer.discard': '취소',
  'admin.xtmCloud.loading': '설정을 불러오는 중…',
  'admin.xtmCloud.loadError': 'XTM Cloud 설정을 불러올 수 없습니다.',
  'admin.xtmCloud.connection.title': 'XTM Cloud 연결',
  'admin.xtmCloud.connection.description': 'XTM Go를 조직의 XTM Cloud 계정에 연결하고 휴먼 인 더 센터로 보내는 파일의 기본 고객과 프로젝트 템플릿을 선택합니다. 기본 URL은 조직의 SSO 설정에서 가져오며 여기에서 변경할 수 없습니다.',
  'admin.xtmCloud.baseUrl': '기본 URL',
  'admin.xtmCloud.client': '클라이언트',
  'admin.xtmCloud.username': '사용자 이름',
  'admin.xtmCloud.password': '비밀번호',
  'admin.xtmCloud.passwordSet': '비밀번호 설정됨',
  'admin.xtmCloud.passwordNotSet': '비밀번호 미설정',
  'admin.xtmCloud.saved': '변경 사항이 저장되었습니다.',
  'admin.xtmCloud.credentialsError': '자격 증명을 저장할 수 없습니다.',
  'admin.xtmCloud.credentialsIncomplete': '자격 증명을 저장하려면 클라이언트, 사용자 이름, 비밀번호가 모두 필요합니다.',
  'admin.xtmCloud.customer.locked': '고객을 불러오려면 먼저 자격 증명을 저장하세요.',
  'admin.xtmCloud.customer.label': '기본 고객',
  'admin.xtmCloud.customer.select': '고객 선택',
  'admin.xtmCloud.customer.loading': '고객을 불러오는 중…',
  'admin.xtmCloud.customer.unavailable': '이 고객은 XTM Cloud에서 더 이상 활성 상태가 아닙니다. 다른 고객을 선택하세요.',
  'admin.xtmCloud.customerError': '선택한 고객을 저장할 수 없습니다.',
  'admin.xtmCloud.template.select': '기본 프로젝트 템플릿',
  'admin.xtmCloud.template.none': '템플릿 없음',
  'admin.xtmCloud.template.global': '전역',
  'admin.xtmCloud.template.locked': '프로젝트 템플릿을 선택하려면 먼저 고객을 선택하세요.',
  'admin.xtmCloud.template.loadFailed': '프로젝트 템플릿을 불러올 수 없습니다.',
  'admin.xtmCloud.template.unavailable': '이 템플릿은 XTM Cloud에 더 이상 없습니다. 다른 템플릿을 선택하세요.',
  'admin.xtmCloud.templateError': '프로젝트 템플릿을 저장할 수 없습니다.',
  'admin.xtmCloud.problem.authentication.title': 'XTM Cloud가 저장된 인증 정보를 거부했습니다',
  'admin.xtmCloud.problem.authentication.body': '아래의 클라이언트와 사용자 이름을 확인한 뒤 비밀번호를 다시 입력하고 저장하세요. XTM Cloud는 저장된 비밀번호를 반환하지 않으므로 확인할 수 없고 교체만 가능합니다.',
  'admin.xtmCloud.problem.unavailable.title': 'XTM Cloud가 응답하지 않습니다',
  'admin.xtmCloud.problem.unavailable.body': '일시적인 문제이며 저장된 인증 정보에는 이상이 없습니다. 잠시 후 다시 시도하세요. 비밀번호를 변경할 필요는 없습니다.',
  'admin.xtmCloud.problem.reference': '참조: {id}',
  'admin.xtmCloud.none': '—',
  'admin.xtmCloud.llm.description': '번역에 사용할 AI 커넥터를 선택하세요.',
  'admin.xtmCloud.llm.riskAssessmentOverride': '이 커넥터는 AI 위험 평가에도 사용되며, 해당 기능에 구성된 기본 커넥터를 재정의합니다.',
  'admin.xtmCloud.tools.riskAssessment': '위험 평가',
  'admin.xtmCloud.tools.mtLlmGateway': 'XTM Gateway',
  'admin.xtmCloud.tools.newTab': '(새 탭에서 열림)',
  'admin.xtmCloud.llm.select': '커넥터 선택',
  'admin.xtmCloud.llm.saved': '설정이 저장되었습니다.',
  'admin.xtmCloud.llm.error': '설정을 저장할 수 없습니다.',
  'admin.xtmCloud.llm.loadError': '커넥터를 불러올 수 없습니다.',
  'admin.xtmCloud.llm.loading': '커넥터를 불러오는 중…',
  'admin.xtmCloud.llm.unavailable': '사용할 수 없는 커넥터',
  'admin.xtmCloud.llm.missing': '저장된 커넥터를 더 이상 사용할 수 없습니다. 비활성화되었거나 삭제되었을 수 있습니다. 다른 커넥터를 선택하세요.',
  'admin.xtmCloud.llm.nav.problem': '저장된 LLM 커넥터를 더 이상 사용할 수 없습니다',
'admin.xtmCloud.llm.translationMode': 'Translation mode',  'admin.xtmCloud.llm.mode.single': 'Single',  'admin.xtmCloud.llm.mode.batch': 'Batch',  'admin.xtmCloud.llm.batchSize': 'Batch size',  'admin.xtmCloud.llm.batchSize.hint': '배치당 1–50개 문서',
  'translatedBatches.title': '번역된 파일',
  'translatedBatches.searchPlaceholder': '파일 이름으로 검색…',
  'translatedBatches.loading': '배치를 불러오는 중…',
  'translatedBatches.error': '번역된 배치를 불러올 수 없습니다.',
  'translatedBatches.empty': '배치를 찾을 수 없습니다.',
  'translatedBatches.downloadAll': '모두 다운로드',
  'translatedBatches.openInXtm': 'XTM Cloud에서 열기',
  'translatedBatches.filesLoading': '파일을 불러오는 중…',
  'translatedBatches.filesError': '이 배치의 파일을 불러올 수 없습니다.',
  'translatedBatches.noFiles': '이 배치에 번역된 파일이 없습니다.',
  'translatedBatches.prev': '이전',
  'translatedBatches.next': '다음',
  'translatedBatches.pageOf': '{total}페이지 중 {current}페이지',
  'translatedBatches.count': '{count, plural, other {배치 #개}}',
  'translatedBatches.fileCount': '{count, plural, other {파일 #개}}',
  'translatedBatches.fileMeta': '{language} · {source}에서',
  'translatedBatches.moreLanguages': '+{count}',
  'translatedBatches.expand': '번역된 파일 표시',
  'translatedBatches.collapse': '번역된 파일 숨기기',
  'translatedBatches.download': '다운로드',
  'translatedBatches.downloading': '다운로드 중…',
  'translatedBatches.downloadFile': '{filename} 다운로드',
  'translatedBatches.zipping': 'ZIP 준비 중…',
  'translatedBatches.status.inProgress': '진행 중',
  'translatedBatches.status.failed': '실패',
  'translatedBatches.status.expired': '만료됨',
  'translatedBatches.moreFiles': '+{count}',
  'translatedBatches.readyOf': '{total}개 중 {ready}개 완료',
  'translatedBatches.state.translating': '번역 중',
  'translatedBatches.state.inXtmCloud': '번역가 작업 중',
  'translatedBatches.state.inXtmCloud.tooltip': 'XTM Cloud의 번역가가 이 파일을 작업하고 있습니다. 며칠이 걸릴 수 있으며, 완료되면 이메일로 알려드립니다.',
  'translatedBatches.state.unavailable': 'XTM Cloud에만 있음',
  'translatedBatches.state.unavailable.tooltip': '번역은 완료되었지만 파일을 XTM Go로 가져오지 못했습니다. XTM Cloud 프로젝트를 열어 받으세요.',
  'translatedBatches.state.failed': '실패',
  'translatedBatches.noResults': '‘{query}’과 일치하는 항목이 없습니다.',
  'translatedBatches.noResultsHint': '다른 파일 이름으로 시도해 보세요.',
  'translatedBatches.emptyHint': '번역한 파일이 여기에 표시됩니다.',
  'translatedBatches.clearSearch': '검색 지우기',
  'translatedBatches.pagination': '페이지 나누기',
  'translatedBatches.single.title': '번역된 배치',
  'translatedBatches.single.backToAll': '모든 번역된 파일',
  'translatedBatches.single.notFound': '이 배치가 존재하지 않거나 읽을 권한이 없습니다.',
  'translatedBatches.single.notFoundHint': '링크를 확인하거나 번역된 파일 전체를 여세요.',
  'translatedBatches.single.error': '이 배치를 불러올 수 없습니다.',
  'admin.styleGuides.title': '스타일 가이드',
  'admin.styleGuides.nav.problem': '기본 스타일 가이드가 더 이상 존재하지 않음',
  'admin.styleGuides.description': 'XTM Go는 스타일 가이드를 XTM Cloud 및 기타 XTM 제품과 공유하므로 여기에서 편집하거나 삭제한 내용은 모든 곳에 적용됩니다. 단, 아래에서 선택한 기본값은 XTM Go의 AI-Direct 레인에만 적용됩니다.',
  'admin.styleGuides.summary.using': 'AI-Direct 번역에는 기본적으로 {name}이(가) 사용됩니다.',
  'admin.styleGuides.summary.none': '기본 스타일 가이드가 없습니다. AI-Direct 번역은 스타일 가이드 없이 실행됩니다.',
  'admin.styleGuides.create': '새 스타일 가이드',
  'admin.styleGuides.edit': '{name} 편집',
  'admin.styleGuides.delete': '{name} 삭제',
  'admin.styleGuides.action.edit': '편집',
  'admin.styleGuides.action.delete': '삭제',
  'admin.styleGuides.action.useNoDefault': '스타일 가이드 사용 안 함',
  'admin.styleGuides.delete.title': '{name}을(를) 삭제할까요?',
  'admin.styleGuides.delete.body': 'XTM Cloud를 포함해 사용되는 모든 곳에서 모든 사용자에 대해 {name}이(가) 영구적으로 삭제됩니다.',
  'admin.styleGuides.delete.bodySelected': 'XTM Cloud를 포함해 사용되는 모든 곳에서 모든 사용자에 대해 {name}이(가) 영구적으로 삭제됩니다. 기본 스타일 가이드이므로 다른 기본값 또는 "스타일 가이드 없음"을 선택할 때까지 AI-Direct 번역이 실패합니다.',
  'admin.styleGuides.delete.confirm': '삭제',
  'admin.styleGuides.delete.cancel': '취소',
  'admin.styleGuides.delete.error': '{name}을(를) 삭제할 수 없습니다. 변경된 내용은 없습니다.',
  'admin.styleGuides.delete.busy': '지금은 {name}을(를) 삭제할 수 없습니다. 잠시 후 다시 시도하세요.',
  'admin.styleGuides.loadError': '스타일 가이드를 읽지 못했습니다. 읽기 문제이며, 스타일 가이드가 없다는 뜻은 아닙니다. 기본 스타일 가이드는 변경되지 않았습니다.',
  'admin.styleGuides.retry': '다시 시도',
  'admin.styleGuides.loadFailedUseNone.hint': '스타일 가이드를 불러올 수 없는 동안에는 기본 스타일 가이드를 해제하여 AI-Direct 번역이 다시 작동하도록 할 수 있습니다.',
  'admin.styleGuides.loadFailedUseNone.done': '이제 기본 스타일 가이드가 없습니다. AI-Direct 번역은 스타일 가이드 없이 실행됩니다.',
  'admin.styleGuides.noLanguages': '언어 섹션 없음',
  'admin.styleGuides.saveError': '저장하지 못했습니다. 기본값은 계속 {previous}입니다.',
  'admin.styleGuides.saveErrorUnchanged': '저장하지 못했습니다. 기본 스타일 가이드는 변경되지 않았습니다.',
  'admin.styleGuides.noDefault': '스타일 가이드 없음',
  'admin.styleGuides.noDefault.description': 'AI-Direct 번역은 스타일 가이드 없이 실행됩니다.',
  'admin.styleGuides.notUsedByXtmGo': 'XTM Go에서 사용하지 않음',
  'admin.styleGuides.warning.missing': '{name}이(가) 기본값이었지만 더 이상 존재하지 않습니다({date}에 확인됨). 다른 기본값 또는 "스타일 가이드 없음"을 선택할 때까지 AI-Direct 번역이 실패합니다.',
  'admin.styleGuides.column.name': '이름',
  'admin.styleGuides.column.languages': '언어',
  'admin.styleGuides.column.updated': '업데이트',
  'admin.styleGuides.column.default': '기본값',
  'admin.styleGuides.column.actions': '작업',
  'admin.styleGuides.default.checked': '기본값',
  'admin.styleGuides.default.unchecked': '기본값으로 설정',
  'admin.styleGuides.default.noneSr': '스타일 가이드 없음',
  'admin.styleGuides.editor.loading': '스타일 가이드 편집기를 여는 중…',
  'admin.styleGuides.editor.loadError': '스타일 가이드 편집기를 불러올 수 없습니다. 스타일 가이드는 변경되지 않았습니다.',
  'admin.styleGuides.editor.back': '스타일 가이드로 돌아가기',
  'admin.styleGuides.editor.authOrganization': '스타일 가이드용 조직 ID가 구성되지 않았습니다. XTM Cloud 연결 설정에서 XTM Cloud 클라이언트를 설정하세요.',
  'admin.styleGuides.editor.authForbidden': '더 이상 스타일 가이드를 편집할 권한이 없습니다.',
  'admin.styleGuides.editor.authFailed': '편집 세션이 종료되었습니다. 계속하려면 편집기를 다시 여세요. 저장하지 않은 변경 사항은 나가기 전까지 유지됩니다.',
  'admin.styleGuides.editor.unavailable': '이 스타일 가이드를 사용할 수 없습니다.',
  'admin.styleGuides.editor.navigationNote': '섹션을 전환하거나 뒤로 가면 저장하지 않은 변경 사항이 사라집니다. 편집기에서 취소 또는 저장을 사용하세요.',

  // ── Language issues (COPA-877, COPA-878): draft, needs translation review ──
  'languageIssue.FILE_NOT_CREATED': '{language}: 번역된 파일을 만들 수 없습니다.',
  'languageIssue.FILE_NOT_CREATED_IN_TIME': '{language}: 번역된 파일을 제시간에 만들 수 없습니다.',
  'languageIssue.TOO_MUCH_UNTRANSLATED': '{language}: 번역하지 못한 텍스트가 너무 많습니다.',
  'languageIssue.CONNECTOR_STALLED': '{language}: AI-Direct 레인에서 LLM 커넥터가 응답을 멈췄습니다.',
  'languageIssue.CONNECTOR_UNAVAILABLE': '{language}: AI-Direct 레인에서 LLM 커넥터에 연결할 수 없습니다.',
  'languageIssue.STYLE_GUIDE_UNAVAILABLE': '{language}: 조직의 스타일 가이드를 불러올 수 없습니다. 다시 시도하거나 파일을 XTM Cloud로 보내세요.',
  'languageIssue.STYLE_GUIDE_DELETED': '{language}: 조직의 스타일 가이드가 삭제되었습니다. 관리자에게 다른 옵션을 선택해 달라고 요청하거나 파일을 XTM Cloud로 보내세요.',
  'languageIssue.STYLE_GUIDE_NOT_CONFIGURED': '{language}: 연결이 설정되지 않아 XTM Go가 조직의 스타일 가이드에 접근할 수 없습니다. 관리자에게 XTM Cloud 연결을 확인해 달라고 요청하거나 파일을 XTM Cloud로 보내세요.',
  'languageIssue.STYLE_GUIDE_FILE_UNAVAILABLE': '{language}: 이 파일에 선택한 스타일 가이드를 불러올 수 없습니다. 다시 시도하거나 파일을 XTM Cloud로 보내세요.',
  'languageIssue.STYLE_GUIDE_FILE_DELETED': '{language}: 이 파일에 선택한 스타일 가이드가 삭제되었습니다. 파일을 다시 업로드하거나 XTM Cloud로 보내세요.',
  'languageIssue.DELIVERED_WITH_UNTRANSLATED': '{language}: LLM 커넥터가 응답을 멈춰 {untranslatedSegments, plural, one {# 개 세그먼트} other {# 개 세그먼트}}가 원본 언어로 남은 채 전달되었습니다.',
  'languageIssue.STOPPED_UNEXPECTEDLY': '{language}: 번역이 예기치 않게 중지되었습니다. 다시 시도하세요.',
  'languageIssue.CONNECTOR_NOT_CONFIGURED': '{language}: 조직에 설정된 LLM 커넥터가 없습니다. 관리자에게 설정을 요청하거나 파일을 XTM Cloud로 보내세요.',
  'languageIssue.UNSUPPORTED_STRUCTURE': '{language}: 이 파일의 구조는 지원되지 않습니다. 파일을 XTM Cloud로 보내세요.',
  'languageIssue.SOURCE_FILE_MISSING': '{language}: 번역에 필요한 파일을 더 이상 사용할 수 없습니다. 파일을 다시 업로드하세요.',
  'languageIssue.PARSED_DOCUMENT_UNREADABLE': '{language}: 번역된 파일을 만들 수 없습니다. 파일을 다시 업로드하세요.',
  'languageIssue.UPLOADED_BEFORE_UPDATE': '{language}: 파일을 다시 업로드하세요. 이 파일은 업데이트 전에 업로드되었습니다.',
  'languageIssue.SOURCE_LANGUAGE_NO_CONNECTOR': '{language}: LLM 커넥터가 설정되지 않아 원본 언어를 감지할 수 없습니다. 관리자에게 설정을 요청하세요.',
  'languageIssue.SOURCE_LANGUAGE_CONNECTOR_FAILED': '{language}: LLM 커넥터가 응답하지 않아 원본 언어를 감지할 수 없습니다. 다시 시도하세요.',
  'languageIssue.XTM_CLOUD_CONNECTION': '{language}: XTM Go가 XTM Cloud에 연결할 수 없습니다. 관리자에게 XTM Cloud 연결을 확인해 달라고 요청하세요.',
  'languageIssue.XTM_CLOUD_UNSUPPORTED_FORMAT': '{language}: XTM Cloud는 이 파일 형식을 지원하지 않습니다.',
  'languageIssue.XTM_CLOUD_PASSWORD_PROTECTED': '{language}: XTM Cloud가 파일을 거부했습니다. 암호로 보호된 파일일 수 있습니다.',
  'languageIssue.XTM_CLOUD_FILE_TOO_LARGE': '{language}: 파일이 XTM Cloud에서 허용하는 크기보다 큽니다(한도: {limit}).',
  'languageIssue.XTM_CLOUD_FILE_TOO_LARGE_NO_LIMIT': '{language}: 파일이 XTM Cloud에서 허용하는 크기보다 큽니다.',
  'languageIssue.XTM_CLOUD_PROJECT_REFUSED': '{language}: XTM Cloud가 프로젝트를 거부했습니다. 다시 시도하세요.',
  'languageIssue.XTM_CLOUD_PROJECT_MAY_EXIST': '{language}: XTM Cloud 프로젝트(‘{projectName}’)가 이미 있을 수 있습니다. 다시 시도하기 전에 XTM Cloud를 확인하세요.',
  'languageIssue.XTM_CLOUD_HANDOVER_FAILED': '{language}: 파일을 XTM Cloud로 보낼 수 없습니다. 다시 시도하세요.',
  'languageIssue.XTM_CLOUD_TARGET_NOT_RETRIEVED': '{language}: XTM Cloud에서 번역된 파일을 가져올 수 없습니다.',
  'languageIssue.XTM_CLOUD_CUSTOMER_UNAVAILABLE': '{language}: 이 파일에 선택한 XTM Cloud 고객을 더 이상 사용할 수 없습니다. 다른 고객으로 파일을 다시 결정하거나 AI-Direct로 보내세요.',
  'languageIssue.XTM_CLOUD_TEMPLATE_UNAVAILABLE': '{language}: 이 파일에 선택한 프로젝트 템플릿을 XTM Cloud에서 더 이상 사용할 수 없습니다. 다른 템플릿으로 파일을 다시 결정하거나 AI-Direct로 보내세요.',
  'languageIssue.XTM_CLOUD_DEFAULT_CUSTOMER_UNAVAILABLE': '{language}: 조직의 XTM Cloud 고객을 더 이상 사용할 수 없습니다. 관리자에게 다른 고객을 선택해 달라고 요청하거나 파일을 AI-Direct로 보내세요.',
  'languageIssue.XTM_CLOUD_DEFAULT_TEMPLATE_UNAVAILABLE': '{language}: 조직의 프로젝트 템플릿을 XTM Cloud에서 더 이상 사용할 수 없습니다. 관리자에게 다른 템플릿을 선택해 달라고 요청하거나 파일을 AI-Direct로 보내세요.',
  'languageIssue.UNKNOWN_FAILURE': '{language}: 번역이 예기치 않게 중지되었습니다. 다시 시도하세요.',
  'languageIssue.UNKNOWN_WARNING': '{language}: 경고와 함께 전달되었습니다.',
  'languageIssue.reference': '참조 번호: {uploadBatchId}',
  'languageIssue.copyReference': '참조 번호 복사',
};

export default ko;
